import script from "./UploadJit.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadJit.vue?vue&type=script&setup=true&lang=js"

import "./UploadJit.vue?vue&type=style&index=0&id=2f75a4b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f75a4b2"]])

export default __exports__